module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f62a.387d45cf.svg";